/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export class MVPAppScannerJob implements IJob {
        public jobId: string;
        public creationDate: Date;
        public jobStatus: string;
        public assignedProbe: Models.IProbe;
        public jobInfo: Models.MVPAppScannerJobInfo;
        public jobResult: Models.MVPAppScannerJobResult;
        public jobType: string;
        public jobErrorMessage: string;

        constructor() {
            this.jobId = '';
            this.creationDate = new Date();
            this.jobStatus = '';
            this.assignedProbe = new Models.Probe();
            this.jobInfo = new Models.MVPAppScannerJobInfo();
            this.jobResult = new Models.MVPAppScannerJobResult();
            this.jobType = JobType.MVP_APP_SCANNER;
        }
    }

    export class MVPAppScannerJobResult implements IJobResult {
        public appConnections: AppConnection[];
        public clients: Client[];
        public rtmp: JobResultRTMP;
        public http: JobResultHTTP[];
        public serverClients: ServerClientsInfo;
        
        public static burnish(jobResult: MVPAppScannerJobResult): MVPAppScannerJobResult {
            let result: MVPAppScannerJobResult = new MVPAppScannerJobResult();
            result.appConnections = jobResult.appConnections;
            result.clients = jobResult.clients;
            result.rtmp = jobResult.rtmp;
            result.http = jobResult.http;
            return result;
        }

        constructor() {
            this.appConnections = [];
            this.clients = [];
        }

        public toString(): string {
            let result: string = "";
            
            for (let x: number = 0; x < this.clients.length; x++) {
                if (this.serverClients) {
                    /* tslint:disable */
                    result += this.serverClients.slots[x] !== null ? "\nConnected on " : "\nListen on ";
                    /* tslint:enable */
                }

                result += "Client ID " + (x + 1) + ": ";
                for (let conn of this.clients[x].connections) {
                    result += conn.port + "[" + conn.connection + "]=" + conn.result + " ";
                }
            }

            result += "\nMobile app ports: ";
            for (let app of this.appConnections) {
                result += app.port + "=" + app.result + " ";
            }

            result += "\nHTTP ports: ";
            for (let http of this.http) {
                result += http.port + "=" + http.result + " ";
            }
            
            result += "\nRTMP port: ";
            result += this.rtmp.port + "=" + this.rtmp.result + " ";

            return result;
        }
    }

    export class MVPAppScannerJobRequest implements IJobRequest {
        public probeId: number;
        public jobInfo: IJobInfo;

        constructor() {
            this.probeId = -1;
            this.jobInfo = new MVPAppScannerJobInfo();
        }
    }
    
    export class MVPAppScannerJobInfo implements IJobInfo {
        public networkElementHref: number;
        public networkNode: Models.INetworkNode;
        public networkNodeType: Models.INetworkNodeType;
        public ipAddress: string;
        public clients: number;
        
        constructor() {
            this.networkElementHref = undefined;
            this.ipAddress = '';
        }
    }

    export class AppConnection {
        public host: String;
        public port: number;
        public result: JobItemResult;
    }

    export class Client {
        public id: number;
        public host: String;
        public connections: Connection[];
    }

    export class JobResultRTMP {
        public host: String;
        public port: number;
        public result: JobItemResult;
    }

    export class JobResultHTTP {
        public host: String;
        public port: number;
        public result: JobItemResult;
    }

    export class Connection {
        public host: String;
        public port: number;
        public numclient: number;
        public connection: number;
        public result: JobItemResult;
    }

    export class JobItemResult {
        public static OK: string = "OK";
        public static FAIL: string = "FAIL";
    }
}
